import React from "react";
import { MapPin } from "lucide-react";
import { RelabelCaseRecord } from "src/types";

interface RouteToPillProps {
  case_: RelabelCaseRecord;
  variant?: "default" | "pending";
}

const RouteToPill: React.FC<RouteToPillProps> = ({ case_, variant = "default" }) => {
  const isPending = variant === "pending";
  const sizeClasses = isPending ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs";

  if (case_.routedLocationId) {
    const label = `Route to ${case_.routedLocationDisplayName ?? case_.routedLocationId}${
      isPending ? " (pending)" : ""
    }`;
    return (
      <span
        className={`inline-flex items-center gap-1.5 rounded-full font-medium border bg-emerald-50 text-emerald-700 border-emerald-200 ${sizeClasses}`}
        title={isPending ? "Awaiting placement confirmation" : undefined}
      >
        <MapPin className="h-3 w-3" />
        {label}
      </span>
    );
  }
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-medium border bg-amber-50 text-amber-700 border-amber-200 ${sizeClasses}`}
    >
      <MapPin className="h-3 w-3" />
      Awaiting routing
    </span>
  );
};

export { RouteToPill };
